var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsultancy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520 520",
    style: {
      enableBackground: "new 0 0 520 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_55_x2C__Consulting_x2C__Help_x2C__Seo_x2C__Support"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105,92.5c5.514,0,10-4.486,10-10s-4.486-10-10-10c-5.515,0-10,4.486-10,10S99.485,92.5,105,92.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,213v29c0,3.033,2.467,5.5,5.5,5.5h4.5v-40h-4.5C152.467,207.5,150,209.967,150,213z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 127.5,
    width: 100,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.5,87.5c9.65,0,17.5-7.851,17.5-17.5s-7.85-17.5-17.5-17.5c-9.648,0-17.5,7.851-17.5,17.5S432.852,87.5,442.5,87.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 357.5,
    width: 330,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,192.625v4.875h4.5c8.547,0,15.5,6.953,15.5,15.5v29c0,8.547-6.953,15.5-15.5,15.5h-4.506 c-0.068,8.282-6.82,15-15.119,15H340v35c0,2.406-1.713,4.471-4.078,4.914l-80.001,15c-2.706,0.509-5.326-1.271-5.836-3.992 c-0.509-2.715,1.278-5.327,3.993-5.836L330,303.351V272.5h-14.875c-8.34,0-15.125-6.785-15.125-15.125v-64.75 c0-6.539,4.18-12.105,10-14.212V162.5H210v15.913c5.82,2.106,10,7.673,10,14.212v64.75c0,8.34-6.785,15.125-15.125,15.125h-29.75 c-8.299,0-15.051-6.718-15.119-15H155.5c-8.547,0-15.5-6.953-15.5-15.5v-29c0-8.547,6.953-15.5,15.5-15.5h4.5v-4.875 c0-8.34,6.785-15.125,15.125-15.125H180v-10H95v120h35c2.761,0,5,2.238,5,5s-2.239,5-5,5H95v10h45c2.761,0,5,2.238,5,5 s-2.239,5-5,5H95v10h55c2.761,0,5,2.238,5,5s-2.239,5-5,5H95v10h330v-10h-55c-2.762,0-5-2.238-5-5s2.238-5,5-5h55v-10h-45 c-2.762,0-5-2.238-5-5s2.238-5,5-5h45v-10h-35c-2.762,0-5-2.238-5-5s2.238-5,5-5h35v-120h-85v10h4.875 C353.215,177.5,360,184.285,360,192.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,242v-29c0-3.033-2.467-5.5-5.5-5.5H360v40h4.5C367.533,247.5,370,245.033,370,242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,427.5v15c0,2.762-2.238,5-5,5h-90c-2.762,0-5-2.238-5-5v-15H35.225c2.533,27.994,26.133,50,54.775,50h340 c28.643,0,52.242-22.006,54.775-50H310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,252.5h-25v4.875c0,2.826,2.299,5.125,5.125,5.125h29.75c2.826,0,5.125-2.299,5.125-5.125c0-21.556,0-43.162,0-64.75 c0-2.826-2.299-5.125-5.125-5.125h-29.75c-2.826,0-5.125,2.299-5.125,5.125V242.5h25c2.762,0,5,2.238,5,5 S337.762,252.5,335,252.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,151v245c0,9.859,6.514,18.62,15.893,21.5H215c2.761,0,5,2.238,5,5v15h80v-15c0-2.762,2.238-5,5-5h144.105 C458.486,414.621,465,405.859,465,396V151c0-12.406-10.094-22.5-22.5-22.5H340v29h90c2.762,0,5,2.238,5,5v220 c0,2.762-2.238,5-5,5H90c-2.762,0-5-2.238-5-5v-220c0-2.762,2.238-5,5-5h90v-29H77.5C65.093,128.5,55,138.594,55,151z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,122.5c0-33.084,26.916-60,60-60s60,26.916,60,60v55h10v-55c0-38.598-31.402-70-70-70c-38.599,0-70,31.402-70,70v55 h10V122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,242.5h25v-49.875c0-2.826-2.299-5.125-5.125-5.125h-29.75c-2.826,0-5.125,2.299-5.125,5.125 c0,19.805,0,44.924,0,64.75c0,2.826,2.299,5.125,5.125,5.125h29.75c2.826,0,5.125-2.299,5.125-5.125V252.5h-25 c-2.762,0-5-2.238-5-5S182.238,242.5,185,242.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.5,
    cy: 50,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.5,
    cy: 90,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 60,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 100,
    r: 7.5
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultancy);
export default __webpack_public_path__ + "static/media/consultancy.60e10d1ec2f431784aa641f50e953f03.svg";
export { ForwardRef as ReactComponent };